module.exports = __webpack_public_path__ + "static/img/notice.6a1a780c.svg";